import type { SearchFilter } from '../../services'
import type { GroupedFilters } from '../../services/types/services'

export const mapFiltersToGroupedFilters = (
  filters: SearchFilter[],
): GroupedFilters[] => {
  const groupedFilters: GroupedFilters[] = []
  filters.forEach(x => {
    const group = groupedFilters.find(y => y.group === x.group)

    return group
      ? group.keys.push(x.key)
      : groupedFilters.push({
          group: x.group,
          keys: [x.key],
          userApplied: x.userApplied,
        })
  })
  return groupedFilters
}
